import axios from '@/utils/axios'
import {business, doctorPrefix, operatorPrefix, tenantUserPrefix} from '../../common'
import {getRoles} from '@/utils/cookie'
import {operator, tenantUser} from '@/utils/role'

/**
 * 获取用户信息
 * @param NotNeedErrorMessage
 */
export const getSystemUserInfo = (NotNeedErrorMessage = false) => {
  return axios({
    url: `${business}/tenant/user/getUserInfo`,
    headers: {
      ...(NotNeedErrorMessage ? {'NotNeedErrorMessage': true} : {})
    },
    method: 'get'
  })
}

/**
 * 修改租户管理员信息
 * @param form
 */
export const editTenantAdmin = form => {
  return axios({
    url: `${business}${tenantUserPrefix}/tenant/user/editTenantAdmin`,
    method: 'post',
    data: form
  })
}

/**
 * 获取当前租户的运营中列表
 * @param form -
 */
export const operatorList = (pageInfo, userRole) => {
  return axios({
    url: `${business}${tenantUserPrefix}/tenant/user/operatorList`,
    method: 'post',
    data: pageInfo,
    params: {userRole}
  })
}

/**
 * 审核
 * @param clinicCodes -
 * @returns {*} -
 */
export const approval = clinicCodes => {
  return axios({
    url: `${business}${tenantUserPrefix}/tenant/user/approval`,
    method: 'post',
    data: clinicCodes
  })
}
/**
 * 添加租户人员信息
 * @param form
 */
export const addTenantUser = form => {
  return axios({
    url: `${business}${tenantUserPrefix}/tenant/user/add`,
    method: 'post',
    data: form
  })
}

/**
 * 添加租户人员信息
 * @param form
 */
export const getTenantUserInfo = userCode => {
  return axios({
    url: `${business}${tenantUserPrefix}/tenant/user/info/${userCode}`,
    method: 'get'
  })
}

/**
 * 修改租户人员信息
 * @param form
 * @returns {*}
 */
export const editTenantUserInfo = form => {
  return axios({
    url: `${business}${tenantUserPrefix}/tenant/user/edit`,
    method: 'post',
    data: form
  })
}

/**
 * 删除租户人员信息
 * @param form
 * @returns {*}
 */
export const deleteTenantUser = form => {
  return axios({
    url: `${business}${tenantUserPrefix}/tenant/user/delete`,
    method: 'delete',
    data: form
  })
}

/**
 * 校验身手机号是否重复（租户人员）
 * @param phoneNumber -
 * @param userCode -
 * @returns {*} -
 */
export const phoneNumberExists = (phoneNumber, userCode) => {
  return axios({
    url: `${business}/tenant/user/phoneNumberExists`,
    method: 'get',
    params: {phoneNumber, userCode}
  })
}

/**
 * 校验登录名是否重复（租户人员）
 * @param loginName -
 * @param userCode -
 * @returns {*} -
 */
export const loginNameExists = (loginName, userCode) => {
  return axios({
    url: `${business}/tenant/user/loginNameExists`,
    method: 'get',
    params: {loginName, userCode}
  })
}

/**
 * 修改代理人信息
 * 修改租户人员信息
 * @param form
 */
export const editTenantUser = form => {
  let url
  if (getRoles() === tenantUser) {
    url = `${business}${tenantUserPrefix}/tenant/user/editTenantAdmin`
  } else if (getRoles() === operator) {
    url = `${business}${operatorPrefix}/tenant/user/editOperator`
  }
  return axios({
    url: url,
    method: 'post',
    data: form
  })
}

/**
 * 修改租户产品分类状态
 */
export const editEnableProduct = (editEnableProduct) => {
  return axios({
    url: `${business}${tenantUserPrefix}/tenant/user/${editEnableProduct}/editEnableProduct`,
    method: 'post'
  })
}

/**
 * 获取租户信息
 */
export const getPlatformTenantUserInfo = () => {
  return axios({
    url: `${business}${tenantUserPrefix}/tenant/user/getPlatformTenantUserInfo`,
    method: 'get'
  })
}

/**
 * 获取云诊365用户绑定状态
 */
export const queryYz365BindState = (data) => {
  let url
  if (getRoles() === tenantUser) {
    url = `${business}${tenantUserPrefix}/tenant/user/queryYz365BindState`
  } else if (getRoles() === operator) {
    url = `${business}${operatorPrefix}/tenant/user/queryYz365BindState`
  }
  return axios({
    url: url,
    method: 'get',
    params: data
  })
}

/**
 * 修改云诊365用户绑定状态
 */
export const updateYz365BindState = (data) => {
  let url
  if (getRoles() === tenantUser) {
    url = `${business}${tenantUserPrefix}/tenant/user/updateYz365BindState`
  } else if (getRoles() === operator) {
    url = `${business}${operatorPrefix}/tenant/user/updateYz365BindState`
  }
  return axios({
    url: url,
    data: data,
    method: 'post'
  })
}

/**
 * 修改门店店员信息
 * @param form
 */
export const editStoreUser = form => {
  return axios({
    url: `${business}${doctorPrefix}/user/editStoreUser`,
    method: 'post',
    data: form
  })
}

/**
 * 功能描述：添加店员时验证登录名是否已经存在
 * @param loginName 登录名
 * @param userCode 修改时当前修改数据的userCode
 * @return 验证结果
 */
export const validateLoginNameIfExists = (loginName, userCode) => {
  return axios({
    url: `${business}${doctorPrefix}/user/validate/name`,
    method: 'get',
    params: {loginName, userCode}
  })
}

/**
 * 功能描述：添加店员时验证手机号是否已经存在
 * @param phone 手机号
 * @param userCode 修改时当前修改数据的userCode
 * @return 验证结果
 */
export const validatePhoneIfExists = (phone, userCode) => {
  return axios({
    url: `${business}${doctorPrefix}/user/validate/phone`,
    method: 'get',
    params: {phone, userCode}
  })
}
/**
 * 功能描述：添加店员时验证邮箱是否已经存在
 * @param email 邮箱
 * @param userCode 修改时当前修改数据的userCode
 * @return 验证结果
 */
export const validateEmailIfExists = (email, userCode) => {
  return axios({
    url: `${business}${doctorPrefix}/user/validate/email`,
    method: 'get',
    params: {email, userCode}
  })
}

/**
 * yz365用户单点登录token获取
 * @returns {*}
 */
export const yz365UserTicket2token = (ticket) => {
  return axios({
    url: `${business}/app/yz365/user/ticket2token`,
    method: 'post',
    headers: {
      NotNeedAuthorization: true
    },
    data: {ticket}
  })
}



// WEBPACK FOOTER //
// ./src/api/business/user/index.js